const toggleSidebar = (payload) => ({
    type: 'TOGGLE_SIDEBAR',
    payload,
});

export default {
    toggleSidebar,
}